/**
 * 货币符号映射表
 * 根据货币单位代码返回对应的货币符号
 */
export const CURRENCY_SYMBOL_MAP: Record<string, string> = {
  USD: '$',
  CNY: '¥',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
};

/**
 * 获取货币符号
 * @param currencyUnit 货币单位代码（如 USD, CNY）
 * @param defaultSymbol 默认货币符号，默认为 ¥
 * @returns 对应的货币符号
 */
export const getCurrencySymbol = (currencyUnit?: string, defaultSymbol = '¥'): string => {
  if (!currencyUnit) return defaultSymbol;
  return CURRENCY_SYMBOL_MAP[currencyUnit] || defaultSymbol;
};
